import { Text } from '@/_components';
import styles from './DeliveryNavigation.module.css';
import type { FC } from 'react';
import type { DeliveryNavigationProps } from './DeliveryNavigation.types';

export const DeliveryNavigation: FC<DeliveryNavigationProps> = ({
  children,
  status,
}) => {
  return (
    <nav className={styles.deliveryNavigation}>
      {status === 'sent' ? (
        <Text type="small">
          This page is <b>READ ONLY</b> because the tax return has been
          delivered.
        </Text>
      ) : (
        <div />
      )}
      {children}
    </nav>
  );
};
